module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Safe-chat-ce6a730671c68ad0129e024be942d2f2.svg";